import React, { memo } from "react";
import { Stack } from "investira.react.components";
import { HighchartsReact } from "investira.react.charts";
import { ATIVO_MERCADO, ATIVO_TIPO } from "@investirapri/financa.js/lib/enums";
import { formats } from "investira.sdk";

const PosicaoAbertaChart = memo((props) => {
  const { data = [] } = props;

  const reduceData = (pData = [], pGroupBy = "mercado") => {
    const xGrouped = pData.reduce((xAcc, xItem) => {
      const xKey = xItem[pGroupBy];

      if (!xAcc[xKey]) {
        xAcc[xKey] = {
          financeiro: 0,
          quantidade_ativos: 0,
        };
      }

      xAcc[xKey].financeiro += xItem.financeiro;
      xAcc[xKey].quantidade_ativos += xItem.quantidade_ativos;

      return xAcc;
    }, {});

    return Object.entries(xGrouped).map(([xKey, xValue]) => ({
      name: ATIVO_MERCADO[xKey].descricao,
      y: xValue.financeiro,
      drilldown: xKey,
      metadata: {
        quantidade_ativos: xValue.quantidade_ativos,
        financeiro: formats.formatNumber(xValue.financeiro, 2, true, true),
        ativos: pData
          .filter((xItem) => xItem[pGroupBy] === xKey)
          .map((xItem) => xItem),
      },
    }));
  };

  const ativoTipoData = (pData) => {
    return pData.map((xItem) => {
      return {
        id: xItem.drilldown,
        name: xItem.name,
        data: xItem.metadata.ativos.map((xAtivo) => {
          return {
            name: ATIVO_TIPO[xAtivo.ativo_tipo_id].descricao,
            y: xAtivo.financeiro,
            metadata: {
              financeiro: formats.formatNumber(
                xAtivo.financeiro,
                2,
                true,
                true
              ),
              quantidade_ativos: xAtivo.quantidade_ativos,
            },
          };
        }),
      };
    });
  };

  const xMercado = reduceData(data, "mercado");
  const xAtivosTipo = ativoTipoData(xMercado);

  const xOptions = {
    chart: {
      type: "pie",
    },
    title: false,
    plotOptions: {
      pie: {
        innerSize: "50%",
        dataLabels: {
          enabled: true,
          //format: "{point.name}: {point.y:.1f}",
          useHTML: true,
          formatter: function () {
            console.log(this.point);
            return `<span style="color: #FFFFFF; text-decoration: none;">${this.point.name}</span>`;
          },
          //color: "#FFFFFF",
          style: {
            color: "#FFFFFF",
            textOutline: "none",
          },
        },
      },
    },
    tooltip: {
      pointFormat: `Financeiro: <b>{point.metadata.financeiro}</b><br>Quantidade de Ativos: <b>{point.metadata.quantidade_ativos}</b>`,
    },
    series: [
      {
        name: "Mercado",
        colorByPoint: true,
        data: xMercado,
      },
    ],
    drilldown: {
      series: xAtivosTipo,
      breadcrumbs: {
        // useHTML: true,
        // formatter: function () {
        //   console.log(this);
        //   return `<span style="color: #FFFFFF; text-decoration: none;"></span>`;
        // },
        style: {
          color: "#FFFFFF",
          fill: "#FFFFFF", // Text color
        },
        buttonTheme: {
          style: {
            color: "#00dfa8", // Text color
          },
          states: {
            hover: {
              fill: "none", // Cor de fundo ao passar o mouse
            },
            select: {
              style: {
                color: "#FFFFFF",
                cursor: "default", // Cor do texto quando selecionado
              },
              fill: "none",
            },
          },
        },
      },
    },
    // navigation: {
    //   breadcrumbs: {
    //     style: {
    //       fill: "#FFFFFF", // Text color
    //       background: "none",
    //     },
    //     buttonTheme: {
    //       style: {
    //         fill: "#FFFFFF",
    //         color: "#00dfa8", // Text color
    //         background: "none",
    //       },
    //     },
    //   },
    //   buttonOptions: {
    //     theme: {
    //       fill: "#ffffff",
    //     },
    //   },
    //   menuItemHoverStyle: { background: "none" },
    //   menuStyle: {
    //     background: "none",
    //     color: "#FFFFFF",
    //   },
    //},
  };

  return (
    <Stack flexGrow={0}>
      <HighchartsReact options={xOptions} drilldown />
    </Stack>
  );
});

export default PosicaoAbertaChart;
